import { Route } from '@angular/router';

export default [
  {
    path: 'settings',
    loadComponent: () =>
      import('./../../dashboard/setting/setting.component').then(
        (c) => c.SettingComponent
      ),
  },
  {
    path: 'help',
    loadComponent: () =>
      import('./../../dashboard/help-center/help-center.component').then(
        (c) => c.HelpCenterComponent
      ),
  },
  {
    path: 'today',
    loadComponent: () =>
      import('./../../dashboard/today/today.component').then(
        (c) => c.TodayComponent
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'today',
  },
] satisfies Route[];
